module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enterQuestion":"Enter a question","requiredField":"Required field to fill in"}}')
  delete Component.options._Ctor
}
